import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import "./App.css";
import "./index.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import ReservationsPage from "./pages/ReservationsPage";
import VipPage from "./pages/VipPage";
import GalleryPage from "./pages/GalleryPage";
import MenuPage from "./pages/MenuPage";
import CareersPage from "./pages/CareersPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminReservations from "./pages/admin/AdminReservations";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminFloorPlans from "./pages/admin/AdminFloorPlans";
import AdminMenu from "./pages/admin/AdminMenu";
import AdminMedia from "./pages/admin/AdminMedia";
import AdminSettings from "./pages/admin/AdminSettings";
import { settings as settingsApi } from "./lib/api";
import { ReservationModalProvider } from "./contexts/ReservationModalContext";
import MrBlackBookingModal from "./components/MrBlackBookingModal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicShell({ children, siteSettings }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer siteSettings={siteSettings} />
    </>
  );
}

function App() {
  const [siteSettings, setSiteSettings] = useState(null);
  useEffect(() => { settingsApi.get().then(setSiteSettings).catch(() => {}); }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ReservationModalProvider>
        <ScrollToTop />
        <MrBlackBookingModal />
        <Toaster position="bottom-right" theme="dark" toastOptions={{
          style: { background: "#0F0F10", border: "1px solid rgba(212,175,55,0.4)", color: "#fff", borderRadius: 0, fontFamily: "Outfit, sans-serif", letterSpacing: "0.05em" },
        }} />
        <Routes>
          <Route path="/" element={<PublicShell siteSettings={siteSettings}><HomePage /></PublicShell>} />
          <Route path="/events" element={<PublicShell siteSettings={siteSettings}><EventsPage /></PublicShell>} />
          <Route path="/events/:id" element={<PublicShell siteSettings={siteSettings}><EventDetailPage /></PublicShell>} />
          <Route path="/reservations" element={<PublicShell siteSettings={siteSettings}><ReservationsPage /></PublicShell>} />
          <Route path="/vip" element={<PublicShell siteSettings={siteSettings}><VipPage /></PublicShell>} />
          <Route path="/gallery" element={<PublicShell siteSettings={siteSettings}><GalleryPage /></PublicShell>} />
          <Route path="/menu" element={<PublicShell siteSettings={siteSettings}><MenuPage /></PublicShell>} />
          <Route path="/careers" element={<PublicShell siteSettings={siteSettings}><CareersPage /></PublicShell>} />
          <Route path="/blog" element={<PublicShell siteSettings={siteSettings}><BlogPage /></PublicShell>} />
          <Route path="/blog/:slug" element={<PublicShell siteSettings={siteSettings}><BlogPostPage /></PublicShell>} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="reservations" element={<AdminReservations />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="floor-plans" element={<AdminFloorPlans />} />
            <Route path="menu" element={<AdminMenu />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        </ReservationModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
